{
  "name": "light-paper",
  "_note": "가벼운 종이 카드. 정/동마찰 차이를 크게 해 느린 스와이프에서 자글거림이 또렷하고, 빠르면 한 번에 미끄러진다. 복귀는 더 튕긴다.",
  "swipe": {
    "stickResistance": 0.9,
    "slipResistance": 0.35,
    "bendStiffness": 7,
    "bendLimit": 0.7,
    "mass": 0.006,
    "returnSpeed": 26,
    "returnBounce": 0.3,
    "flySpin": 0.35
  },
  "sound": {
    "friction": { "freqMin": 1800, "freqMax": 6500, "q": 2.0, "gain": 0.55 },
    "click": { "gain": 0.6, "hpf": 4200 },
    "thud": { "freq": 110, "dur": 0.07 }
  }
}
